/**
 * Where the inbox lives.
 *
 * A constant rather than a literal in two places: the dropzone pill links here from a portal above
 * every screen, and a path that drifted would leave the only notice that a file was not filed
 * pointing at nothing.
 */
export const FILE_INBOX_PATH = "/organization/data/file-inbox";
